import type { GetStaticProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { TermsOfUse } from "../../components/TermsOfUse/TermsOfUse";

const Page: NextPage = () => {
  return (
    <>
      <TermsOfUse />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  };
};

export default Page;
